import Logger from '../util/Logger';
import { popinApi } from './api';

export const themeApi = {
  createTheme: (theme) => {
    return Promise.resolve().then(() => {
      if (!theme) {
        Logger.info('reject createTheme()');
        throw Error('Must pass theme');
      } else {
        return popinApi.post(`/themes`, theme);
      }
    });
  },

  getTheme: (themeId) => {
    return Promise.resolve().then(() => {
      if (!themeId) {
        Logger.info('reject getTheme()');
        throw Error('Must pass a themeId');
      } else {
        return popinApi.get(`/themes/${themeId}`);
      }
    });
  },

  upsertDefaultTheme: (theme) => {
    return Promise.resolve().then(() => {
      if (!theme) {
        Logger.info('reject upsertDefaultTheme()');
        throw Error('Must pass theme');
      } else {
        return popinApi.post(`/themes/default`, theme);
      }
    });
  },

  getDefaultTheme: () => {
    return Promise.resolve().then(() => {
      return popinApi.get(`/themes/default`);
    });
  }
};
